type EventCallback = (data?: any) => void;

class EventBus {
  private listeners: { [key: string]: EventCallback[] } = {};

  on(event: string, callback: EventCallback): void {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);
  }

  off(event: string, callback: EventCallback): void {
    if (!this.listeners[event]) {
      return;
    }
    const index = this.listeners[event].indexOf(callback);
    if (index > -1) {
      this.listeners[event].splice(index, 1);
    }
  }

  emit(event: string, data?: any): void {
    if (!this.listeners[event]) {
      return;
    }
    for (const callback of this.listeners[event]) {
      callback(data);
    }
  }
}

// Singleton pattern for the EventBus
const eventBus = new EventBus();
export default eventBus;
